export default __webpack_public_path__ + "static/media/bgranger.c226d8d2.jpg";